import React from 'react';
import {Select, TextField, Radios} from 'mui-rff';
import {MenuItem} from '@mui/material';

export const createFormFields = (values, isUpdate, disabled=false) => {
  return [
    {
      size: 6,
      isCopy: true,
      name: 'platformName',
      field: (
        <TextField
          id='platformName'
          name='platformName'
          label='Client name'
          fullWidth
          disabled={disabled}
          required
        />
      ),
    },
    {
      size: 6,
      isCopy: true,
      name: 'wlid',
      field: (
        <TextField
          id='wlid'
          name='wlid'
          label='WLID'
          fullWidth
          disabled={isUpdate||disabled}
          required
        />
      ),
    },
    {
      size: 6,
      isCopy: true,
      name: 'firstName',
      field: (
        <TextField
          id='firstName'
          name='firstName'
          label='First Name'
          fullWidth
          disabled={disabled}
        />
      ),
    },
    {
      size: 6,
      isCopy: true,
      name: 'lastName',
      field: (
        <TextField
          id='lastName'
          name='lastName'
          label='Last Name'
          fullWidth
          disabled={disabled}
        />
      ),
    },
    {
      size: 6,
      isCopy: true,
      name: 'email',
      field: (
        <TextField
          id='email'
          name='email'
          label='Email'
          fullWidth
          disabled={disabled}
        />
      ),
    },
    // {
    //   size: 6,
    //   isCopy: true,
    //   name: 'trackDomain',
    //   field: (
    //     <TextField
    //       id='trackDomain'
    //       name='trackDomain'
    //       label='Track Domain'
    //       fullWidth
    //       placeholder='https://'
    //     />
    //   ),
    // },
    {
      size: 12,
      field: <TextField name='notes' multiline label='Notes' margin='none' disabled={disabled} />,
    },
    {
      size: 6,
      field: (
        <Select
          name='type'
          label='Type'
          formControlProps={{margin: 'none'}}
          multiple
          disabled={disabled}
        >
          <MenuItem value='Advertiser'>Advertiser</MenuItem>
          <MenuItem value='Dsp'>Dsp</MenuItem>
          <MenuItem value='AdExchange'>AdExchange</MenuItem>
        </Select>
      ),
    },
    {
      size: 6,
      field: (
        <Select
          name='adType'
          label='Ad Type'
          formControlProps={{margin: 'none'}}
          multiple
          disabled={disabled}
        >
          <MenuItem value='Banner'>Banner</MenuItem>
          <MenuItem value='Video'>Video</MenuItem>
          <MenuItem value='Native'>Native</MenuItem>
          <MenuItem value='Push'>Push</MenuItem>
          <MenuItem value='Pop'>Pop</MenuItem>
        </Select>
      ),
    },
    {
      size: 12,
      field: (isUpdate ?
        <Radios
          label='Status'
          name='status'
          disabled={!isUpdate||disabled}
          formControlProps={{disabled: !isUpdate||disabled}}
          data={[
            {label: 'Active', value: 'active'},
            {label: 'Paused', value: 'paused'},
            {label: 'Removed', value: 'removed'},
          ]}
        /> : null
      ),
    },
  ];
};
